import { render, staticRenderFns } from "./DocumentsUpload.vue?vue&type=template&id=12778384&scoped=true"
import script from "./DocumentsUpload.vue?vue&type=script&lang=js"
export * from "./DocumentsUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12778384",
  null
  
)

export default component.exports